import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slider from 'react-slick';
import dayjs from 'dayjs';

import { BlurWithLogin, Arrow, Translation } from '../../common';

import Hyphenate from '../../../utils/hyphenate';

import logo from '../../../assets/img/matched/troy_future.png';

const TIMELINE_CENSORED = 'TIMELINE_CENSORED';
const TIMELINE_HEADER = (isClientPortal) =>
  `BOX_TIMELINE_HEADER${isClientPortal ? '_CLIENT' : ''}`;
const TIMELINE_CAROUSEL_HEADER = (isClientPortal) =>
  `TIMELINE_CAROUSEL_HEADER${isClientPortal ? '_CLIENT' : ''}`;
const TIMELINE_CAROUSEL_BOTTOM = (isClientPortal, isPaidFully) =>
  `BOX_TIMELINE${isClientPortal ? '_CLIENT' : isPaidFully ? '_PAID' : ''}`;

const SEPARATOR_REGEX = /([\n\t\- .,;:?!]+)/g;

class TimelineContent extends React.Component {
  sliderWrapperRef = React.createRef();
  state = {};

  render() {
    const { styles, sliderSettings, items, maxWordLength = 20 } = this.props;
    return (
      <div
        className={styles['timeline__content-content']}
        ref={this.sliderWrapperRef}
      >
        <Slider {...sliderSettings}>
          {items &&
            items.map(({ logo, summary, datetime, label, current }, index) => (
              <div className={styles['timeline__content-item']} key={index}>
                <div
                  className={
                    styles[
                      `timeline__content-item-circle${current ? '_active' : ''}`
                    ]
                  }
                />

                <div className={styles['timeline__content-item-image-wrapper']}>
                  {logo ? (
                    <img
                      className={styles['timeline__content-item-image']}
                      src={logo}
                      alt={summary}
                    />
                  ) : (
                    <div className={styles['timeline__content-item-image']}>
                      {label}
                    </div>
                  )}
                </div>

                <div
                  className={
                    styles[
                      `timeline__content-item-datetime-wrapper${
                        current ? '_active' : ''
                      }`
                    ]
                  }
                >
                  <div className={styles['timeline__content-item-datetime']}>
                    {datetime && (
                      <div>{dayjs(datetime).format('DD.MM.YYYY')}</div>
                    )}
                    <div>
                      {summary && summary.length
                        ? summary
                            .split(SEPARATOR_REGEX)
                            .map((word, idx, arr) => {
                              const wordWithSpace = !SEPARATOR_REGEX.test(word)
                                ? word +
                                  (idx !== arr.length - 1 ? arr[idx + 1] : '')
                                : null;
                              return wordWithSpace ? (
                                wordWithSpace.length > maxWordLength ? (
                                  <Hyphenate>{wordWithSpace}</Hyphenate>
                                ) : (
                                  <span>{wordWithSpace}</span>
                                )
                              ) : null;
                            })
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    );
  }
}

export const timelineView = ({
  styles,
  sliderSettings,
  items,
  isClientPortal,
  isPaidFully,
  maxWordLength,
}) => (
  <div className={styles['timeline__content']}>
    <Translation className={styles['timeline__content-header']}>
      {TIMELINE_CAROUSEL_HEADER(isClientPortal)}
    </Translation>
    <TimelineContent
      {...{
        styles,
        sliderSettings,
        items,
        maxWordLength,
      }}
    />
    <Translation className={styles['timeline__content-footer']}>
      {TIMELINE_CAROUSEL_BOTTOM(isClientPortal, isPaidFully)}
    </Translation>
  </div>
);

export const mockData = [
  {
    datetime: new Date().toISOString(),
    logo,
    summary: 'Timeline Item 1',
  },
  {
    datetime: new Date().toISOString(),
    logo,
    summary: 'Timeline Item 2',
  },
  {
    datetime: new Date().toISOString(),
    logo,
    summary: 'Timeline Item 3',
  },
];

export const customArrow = (src, direction, styles) => ({
  className,
  style,
  onClick,
}) => (
  <Arrow
    className={classNames(className, styles['timeline__content-slick-arrow'])}
    style={style}
    onClick={onClick}
    src={src}
    id={`page.home.component.timeline.${direction}-arrow`}
  />
);

const Timeline = ({
  items,
  blur,
  styles,
  headPic,
  sliderSettings,
  isClientPortal,
  isPaidFully,
  maxWordLength,
}) => (
  <div className={styles['timeline__wrapper']}>
    <div className={styles['timeline__head']}>
      <div className={styles['timeline__head-header-wrapper']}>
        <Translation className={styles['timeline__head-header']}>
          {TIMELINE_HEADER(isClientPortal)}
        </Translation>
      </div>
      <img
        className={styles['timeline__head-pic']}
        src={headPic}
        alt="pen-pic"
      />
    </div>
    <div className={styles['timeline__content-wrapper']}>
      <BlurWithLogin
        blur={blur}
        descriptionKey={TIMELINE_CENSORED}
        mockData={timelineView({
          styles,
          sliderSettings,
          isClientPortal,
          items: mockData,
          isPaidFully,
          maxWordLength,
        })}
        buttonClassName={styles['timeline__content-blur-button']}
        buttonId="page.home.component.timeline.logout-button"
      >
        {(items &&
          timelineView({
            styles,
            sliderSettings,
            items,
            isClientPortal,
            isPaidFully,
            maxWordLength,
          })) ||
          null}
      </BlurWithLogin>
    </div>
  </div>
);

Timeline.propTypes = {
  items: PropTypes.array,
  translations: PropTypes.object,
  blur: PropTypes.bool,
  styles: PropTypes.object,
  headPic: PropTypes.string,
  blurDescription: PropTypes.string,
  header: PropTypes.string,
  footer: PropTypes.string,
  sliderSettings: PropTypes.object,
};

export default Timeline;
